import { Stack } from '@mui/material';

import StyledButton from '../../components/shared/Button/StyledButton';
import Logo from '../../components/shared/Logo/Logo';
import StyledNotFound from './StyledNotFound';
import { useTranslation } from '../../hooks/useTranslation';

const AccessDenied = () => {
  const { t } = useTranslation();

  const handleGoToDashboard = () => {
    window.location.href = '/dashboard';
  };

  return (
    <StyledNotFound>
      <Logo />
      <Stack sx={{ width: '10%' }} spacing={2}>
        <h1>{t('Access Denied')}</h1>
        <p>{t("You don't have permission to view this page.")}</p>
        <StyledButton
          variant="contained"
          color="primary"
          size="small"
          onClick={handleGoToDashboard}
        >
          {t('Go To Dashboard')}
        </StyledButton>
      </Stack>
    </StyledNotFound>
  );
};

export default AccessDenied;
